<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Reclamos</h4>
            <div class="small text-muted">Gestión y administración de pedidos de asistencia</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <!-- Gráficos sobre reclamos -->
          <b-card>
            <iframe
              src="https://app.tables.com.ar/backend/public/php/interface/slug/43-graficos-reclamos"
              style="width: 100%; height: 600px; border: none;"
              frameborder="0">
            </iframe>
          </b-card>
        </b-col>

        <b-col md="3" v-if="hasAnyAccess">
          <b-list-group>
            <b-list-group-item v-if="permissions.pedidosAsistencia" href="#" class="flex-column align-items-start" @click="openPedidosAsistencia()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">PEDIDOS DE ASISTENCIA</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Pedidos de asistencia
              </p>
            </b-list-group-item>

            <b-list-group-item v-if="permissions.registroSalida" href="#" class="flex-column align-items-start" @click="openRegistroSalida()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">REGISTRO DE SALIDA DE FÁBRICA</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Registro de salida de fábrica
              </p>
            </b-list-group-item>

            <b-list-group-item v-if="permissions.recepcionDeposito" href="#" class="flex-column align-items-start" @click="openRecepcionDeposito()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">REGISTRO DE RECEPCIÓN EN DEPÓSITO</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Registro de recepción en depósito
              </p>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.RECLAMOS,
          profile_id: Profiles.PERSONAL,
          view_reference: '210.Dashboard',
          elements: {}
        },
        primaryColor: '',
        permissions: {
          pedidosAsistencia: false,
          registroSalida: false,
          recepcionDeposito: false
        }
      }
    },
    computed: {
      hasAnyAccess() {
        return this.permissions.pedidosAsistencia ||
               this.permissions.registroSalida ||
               this.permissions.recepcionDeposito
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      // No validar permisos para el dashboard, permitir acceso si tiene el módulo
      // Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
      this.checkPermissions()
      window.addEventListener('message', this.handleIframeMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleIframeMessage)
    },
    methods: {
      checkPermissions() {
        // Obtener los permisos del usuario desde la sesión
        const session = Session.getSession()
        if (!session || !session.auth || !session.auth.user || !session.auth.user.permissions) {
          return
        }

        // Los permisos de vistas están en permissions.items
        const viewPermissions = session.auth.user.permissions.items

        // Verificar cada vista buscando en items
        this.permissions.pedidosAsistencia = viewPermissions.some(
          p => p.module_id === Modules.RECLAMOS &&
               p.profile_id === Profiles.PERSONAL &&
               p.reference === '211.Pedidos de Asistencia'
        )

        this.permissions.registroSalida = viewPermissions.some(
          p => p.module_id === Modules.RECLAMOS &&
               p.profile_id === Profiles.PERSONAL &&
               p.reference === '212.Registro Salida Fábrica'
        )

        this.permissions.recepcionDeposito = viewPermissions.some(
          p => p.module_id === Modules.RECLAMOS &&
               p.profile_id === Profiles.PERSONAL &&
               p.reference === '213.Recepción en Depósito'
        )
      },
      setup () {
        if(Session.getSession().settings) {
          this.primaryColor = Session.getSession().settings.color_primary

          this.createCSS()
        }
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },

      handleIframeMessage(event) {
        if (event.data && event.data.action === 'openReclamos') {
          this.$router.push({ name: 'ReclamosStaffPedidosAsistencia', query: { src: event.data.src } })
        }
      },
      openPedidosAsistencia() {
        this.$router.push({ name: 'ReclamosStaffPedidosAsistencia' })
      },

      openRegistroSalida() {
        this.$router.push({ name: 'ReclamosStaffRegistroSalida' })
      },

      openRecepcionDeposito() {
        this.$router.push({ name: 'ReclamosStaffRecepcionDeposito' })
      }
    }

  }
</script>

<style>

</style>
